import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import dayjs from "dayjs";
import * as React from "react";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import NoDataFound from "../../../CustomComponents/NoDataFound";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const ConditionsAndDeviationsTab = (props) => {
  const [conditionRows, setconditionRows] = useState([]);
  const losCustomerData = useSelector(
    (state) => state.disbursementLosCustomerData.losCustomerData
  );
  const conditionColumns = [
    {
      field: "condition",
      headerName: "Condition",
      headerAlign: "center",
      type: "string",
      hideable: false,
      sortable: false,
      flex: 250,
      align: "left",
    },
    {
      field: "date",
      headerName: "Approved Date",
      headerAlign: "center",
      type: "string",
      flex: 194,
      align: "right",
      editable: false,
    },
    {
      field: "status",
      headerName: "Deviation Status",
      headerAlign: "center",
      type: "string",
      hideable: false,
      sortable: false,
      flex: 250,
      align: "center",
      renderCell: (params) => {
        return (
          <Chip
            label={
              params.value !== null &&
              params.value !== undefined &&
              params.value !== ""
                ? params.value
                : "Not Approved"
            }
            component="div"
            sx={{ color: "white", bgcolor: "Green", width: "90%" }}
          />
        );
      },
    },
  ];

  useEffect(() => {
    const conditionRowsData = [
      {
        id: 1,
        condition: "Credit ",
        date: losCustomerData.creditApprovedDate
          ? dayjs(new Date(losCustomerData.creditApprovedDate)).format(
              "DD/MM/YYYY"
            )
          : losCustomerData.creditApprovedDate,
        status: losCustomerData.creditDeviationStatus,
      },
      {
        id: 2,
        condition: "Legal ",
        date: losCustomerData.legalApprovedDate
          ? dayjs(new Date(losCustomerData.legalApprovedDate)).format(
              "DD/MM/YYYY"
            )
          : losCustomerData.legalApprovedDate,
        status: losCustomerData.legalDeviationStatus,
      },
      {
        id: 3,
        condition: "Technical ",
        date: losCustomerData.technicalApprovedDate
          ? dayjs(new Date(losCustomerData.technicalApprovedDate)).format(
              "DD/MM/YYYY"
            )
          : losCustomerData.technicalApprovedDate,
        status: losCustomerData.techinicalDeviationStatus,
      },
      {
        id: 4,
        condition: "RCU ",
        date: losCustomerData.rcuApprovedDate
          ? dayjs(new Date(losCustomerData.rcuApprovedDate)).format(
              "DD/MM/YYYY"
            )
          : losCustomerData.rcuApprovedDate,
        status: losCustomerData.rcuStatus,
      },
    ];
    setconditionRows([...conditionRowsData]);
  }, [losCustomerData]);

  const loadCardView = (rows, noDataMessage, cardMode) => {
    return (
      <React.Fragment>
        <Grid container>
          <Box
            sx={{
              flex: "1 auto",
            }}
          >
            <React.Fragment>
              <Grid container direction="column" sx={{ flex: "1 auto" }}>
                <Card>
                  <CardHeader
                    subheaderTypographyProps={{
                      color: "#004A92",
                      fontWeight: "700",
                    }}
                    sx={{
                      textAlign: "left",
                      padding: "16px 16px 0px 16px !important",
                    }}
                  />
                  <CardContent sx={{}}>
                    <Grid
                      container
                      item
                      direction="column"
                      alignItems="flex-start"
                      justifyContent="flex-start"
                    >
                      {cardMode === "Conditions" &&
                        rows.map((row, index) => (
                          <>
                            <h4>{row.condition}</h4>
                            <Typography padding="1px">
                              {"Approved Date" + " : " + row.date}
                              <br />
                              {"Deviation Status" + " : " + row.status}
                            </Typography>
                          </>
                        ))}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Divider />
            </React.Fragment>
            {rows.length === 0 && (
              <NoDataFound
                message={noDataMessage}
                imageStyle={{
                  marginTop:
                    props.accordianOpenState && window.innerHeight < 1000
                      ? "20px"
                      : "20%",
                }}
              />
            )}
          </Box>
        </Grid>
      </React.Fragment>
    );
  };

  return (
    <>
      {useMediaQuery("(min-width:1200px)") && (
        <Box sx={{ width: "100%", alignContent: "center" }}>
          <CustomDataGrid
            noDataMessage="No Conditions."
            noDataOnFilterMessage="No Conditions on Applied Filter."
            rows={conditionRows}
            columns={conditionColumns}
            pageSize={10}
            pageSizeOptions={[10]}
            rowHeight={40}
            hideFooter={true}
            gridHeight={"270px"}
            gridWidth={"53.40%"}
            gridLazyLoad={() => {}}
            onSortModelChange={() => {}}
          />
        </Box>
      )}
      {useMediaQuery("(max-width:1200px)") && (
        <React.Fragment>
          {loadCardView(conditionRows, "No Conditions Found", "Conditions")}
        </React.Fragment>
      )}
    </>
  );
};

export default ConditionsAndDeviationsTab;
